function getQueryDict() {
  return window.location.href.includes("7ctos");
}

export default getQueryDict